/**
 * SEC-I5 — httpOnly cookie auth mode flag.
 *
 * Its own module, with NO imports, on purpose. `marchApiEnv` and `authMode`
 * already import each other, and `tokenLifecycle` needs this flag too; putting
 * it in either of those would add a third edge to an existing cycle, and a
 * cycle that resolves today is one refactor away from an undefined-at-import
 * bug in the auth path. A leaf module cannot participate in a cycle at all.
 *
 * WHAT COOKIE MODE IS. The API issues the access token as an httpOnly cookie
 * the browser attaches automatically, so the app never holds a token
 * JavaScript can read. Today tokens live in sessionStorage/localStorage, where
 * a single successful XSS anywhere in the clinical UI hands over a working
 * clinical credential. The known XSS is closed (SEC-I1) and a CSP is in place,
 * so this is defence in depth against a FUTURE injection.
 *
 * MUST MATCH THE BACKEND's `MARCH_AUTH_COOKIE_ENABLED`. Half-on is the one
 * genuinely broken state: cookie mode here with the flag off there means
 * requests carry no credential at all — this app stops sending the header and
 * the backend never set a cookie. Both ship off and are turned on together;
 * see docs/security/COOKIE_AUTH_ROLLOUT.md.
 */

const TRUTHY = new Set(['1', 'true', 'yes', 'on']);

/** True when the app authenticates by httpOnly cookie instead of a Bearer header. */
export function isCookieAuthMode(): boolean {
  const raw = (import.meta.env.VITE_AUTH_COOKIE_MODE ?? '').toString().trim().toLowerCase();
  return TRUTHY.has(raw);
}
